import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Visibility as ViewIcon } from "@mui/icons-material"; // أيقونات جاهزة

const ActionsMenu = ({ anchorEl, handleMenuClose, menuItems }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#fff", 
          borderRadius: "12px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)", 
          minWidth: "180px",
          padding: "5px",
        },
      }}
    >
      {menuItems.map((item, index) => (
        <MenuItem 
          key={index} 
          onClick={item.action} 
          sx={{
            color: item.style?.color || "#333", 
            "&:hover": { backgroundColor: "#f5f5f5" },
            borderRadius: "8px", 
            padding: "8px 12px", 
          }}
        >
          {item.icon && <ListItemIcon sx={{ color: item.style?.color || "#333" }}>{item.icon}</ListItemIcon>}
          <ListItemText primary={item.label} />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ActionsMenu;
